import Link from "next/link";
import { CommunityImage } from "./CommunityImage";
import type { PublicCommunityBrowseData } from "@/lib/community/types";

interface CategoryStoriesRowProps {
  categories: PublicCommunityBrowseData["categories"];
}

export function CategoryStoriesRow({ categories }: CategoryStoriesRowProps) {
  return (
    <div className="grid grid-cols-2 gap-x-4 gap-y-6 sm:grid-cols-3 lg:grid-cols-5">
      {categories.map((category) => {
        const imageUrl = category.cover_image_url;

        return (
          <Link
            key={category.internal_id}
            href={`/community/search?category=${category.internal_id}`}
            className="group min-w-0 rounded-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-600 focus-visible:ring-offset-2"
          >
            <div className="relative aspect-[4/3] overflow-hidden rounded-xl bg-raised">
              {imageUrl ? (
                <CommunityImage
                  src={imageUrl}
                  alt={category.name}
                  fill
                  sizes="(max-width: 639px) 50vw, (max-width: 1023px) 33vw, 20vw"
                  className="transition-transform duration-300 group-hover:scale-[1.03]"
                  containerClassName="absolute inset-0"
                />
              ) : (
                <div className="flex h-full w-full items-center justify-center text-2xl font-semibold text-muted">
                  {category.name.charAt(0)}
                </div>
              )}
            </div>
            <span className="mt-3 block text-sm font-medium leading-snug text-ink transition-colors group-hover:text-brand-green">
              {category.name}
            </span>
          </Link>
        );
      })}
    </div>
  );
}
